import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <div className="bg-muted flex min-h-screen items-center justify-center">
      <div className="text-center">
        <a href="/" className="text-primary hover:text-primary/90 underline">
          <img src="/assets/404_image.png" alt="stromtroopers" loading="eager" decoding="async" />{' '}
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
